import { FC } from "react";

import { NoDataTile } from "@bps/fluent-ui";

export const NoObservationDataTile: FC = () => {
  return (
    <NoDataTile
      styles={{ root: { height: 378 } }}
      textProps={{ text: "No observations recorded" }}
      linkProps={{ hidden: true }}
      showBoxShadow={false}
    />
  );
};
